export default __webpack_public_path__ + "static/media/train.5c2b6caa.ogg";